"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations["default"];
  }
});
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
require("core-js/modules/es.string.trim.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.every.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _formElements = require("@evidation/form-elements");
var _GAD = _interopRequireDefault(require("../GAD7"));
var _validations = _interopRequireWildcard(require("./validations"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var trimSpaces = function trimSpaces() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return value.replace(/\s+/g, '').trim();
};
var questionIsEmpty = function questionIsEmpty() {
  var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return trimSpaces(q).length === 0;
};
var SimpleMatrix = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var question_label = props.question_label,
    questions = props.questions,
    answer_labels = props.answer_labels;
  var _props$meta = props.meta,
    touched = _props$meta.touched,
    error = _props$meta.error,
    _props$input = props.input,
    name = _props$input.name,
    onChange = _props$input.onChange;
  questions = _lodash["default"].map(questions, 'question');
  answer_labels = _lodash["default"].map(answer_labels, 'answer');
  question_label = /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, question_label);
  var hideFirstColumn = questionIsEmpty(props.question_label) && questions.every(questionIsEmpty);
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var handleChange = function handleChange(value) {
    setValue(value);
    onChange(value);
  };
  var shouldShowError = !!(touched && error);
  var errorRowIndexes = (0, _react.useMemo)(function () {
    return shouldShowError ? (0, _validations.findUnansweredQuestionIndexes)({
      questions: questions,
      name: name,
      value: value
    }) : [];
  }, [name, questions, shouldShowError, value]);
  var containerRef = (0, _react.useRef)();
  // An array containing one ref per row element
  var rowRefs = (0, _react.useRef)([]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      getRefForFirstError: function getRefForFirstError() {
        if (errorRowIndexes.length > 0) {
          var firstErrorIndex = errorRowIndexes[0];
          if (rowRefs.current[firstErrorIndex]) {
            return rowRefs.current[firstErrorIndex];
          }
        }
        // Use the container as a fallback ref, just in case.
        return containerRef.current;
      }
    };
  }, [errorRowIndexes]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: containerRef
  }, /*#__PURE__*/_react["default"].createElement(_GAD["default"], (0, _extends2["default"])({}, props, {
    input: _objectSpread(_objectSpread({}, props.input), {}, {
      onChange: handleChange
    }),
    question_label: question_label,
    questions: questions,
    answer_labels: answer_labels,
    hideFirstColumn: hideFirstColumn,
    onChange: handleChange,
    errorRowIndexes: errorRowIndexes,
    rowRefs: rowRefs
  })));
});

// It renders the warning icon on each row, so we don't need to show the
//   primary/default one.
SimpleMatrix.showWarningIconOnError = false;
SimpleMatrix.defaultProps = {
  question_label: '',
  questions: [],
  answer_labels: []
};
SimpleMatrix.propTypes = {
  question_label: _propTypes["default"].string,
  questions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    question: _propTypes["default"].string
  })),
  answer_labels: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    answer: _propTypes["default"].string
  }))
};
var _default = exports["default"] = SimpleMatrix;